<template>
  <div class="row border-bottom border-bottom-1 border-gray-200 py-10">
    <InputDate
        containerClass="col-12 col-md-6 mb-7"
        :name="'expense-date'+id"
        type="text"
        :label="$t('expense.label.expenseDate')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-sm form-control-solid'"
        :isRequired="true"
        size="lg"
        :placeholder="$t('expense.placeholder.date')"
        v-model="feeData.date" />

        <InputAmount
          :label="$t('expense.label.amount')"
          :number="feeData.amount"
          :iso="companyCurrency?.iso ?? symbol"
          :required="true"
          @amount="getAmount"
          containerClass="col-12 col-md-6 mb-7" 
          />
    <Select2
        container-class="form-group col-12 col-md-6 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`expense-reason`+id"
        :label="$t('expense.label.reason')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('expense.label.reason')"
        v-model="feeData.reason_id"
        :IsInputGroup="$can(abilities.CREATE_EXPENSE_REASON)"
        icon="bi bi-plus"
        :clickAddon="$can(abilities.CREATE_EXPENSE_REASON) && openReasonModal">
      <option v-for="reason in reasons" :value="reason.id" :key="reason.id">
        {{ reason.name }}
      </option>
    </Select2>

    <div class="col-6">
      <div class="row align-items-center">
        <div class="col-10 d-flex flex-column justify-content-center">
          <label class="form-label fs-6 fw-bolder text-black required"> {{ $t('expense.label.receipt') }} </label>
          <input
              class="d-none"
              ref="fileInput"
              type="file"
              :name="`expense-reason-${id}-file`"
              :id="`input-expense-reason-${id}-file`"
              @change="handleUpload"
          />
          <div> 
            <button class="btn btn-sm btn-light-primary rounded w-150px h-35px" type="button" @click.prevent="triggerFileInput">
              <i class="bi bi-paperclip fs-4"></i>
              {{ $t('expense.label.attachFiles') }}
            </button>
            <small class="ms-2"> {{ $t('expense.placeholder.attachFiles') }} </small>
            <div class="d-flex flex-wrap mt-3">
              <Card class="mx-2" v-for="(file, index) in feeData.invoices">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <i class="bi bi-file-earmark text-primary fs-4 me-3"></i>
                  {{ file.name }}
                  <i class="bi bi-x fs-2 ms-3 cursor-pointer" @click.prevent="removeFile(index, file)"></i>
                </div>
              </Card>
            </div>
          </div>

        </div>
        <div class="col-2">
          <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteFeeRow(index)">
            <i class="bi bi-trash-fill fs-5"></i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <CreateReasonModal :id="'reason-create-modal'+id" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, ref} from "vue";
import Input from "@/components/Input.vue";
import {useDiscountType} from "@/composables/discountType";
import {useStore} from "vuex";
import InputDate from "@/components/InputDate.vue";
import CreateReasonModal from "@/Modules/Financial/components/Modals/Reason/CreateReasonModal.vue";
import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import InputAmount from "@/components/InputAmount.vue";

const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  fee: {
    type: Object,
    default: () => ({
      date: "",
      amount: 0,
      reason_id: '',
      invoices: []
    })
  },
  symbol: String,
  index: Number,
  id: String,
})
const {discountType} = useDiscountType()

const feeData = ref(props.fee)
const file = ref('')

const reasons = computed(() => store.getters['reason/reasons'])

const openReasonModal = () => {
  $('#reason-create-modal'+props.id).modal('toggle')
}
const handleUpload = (e) => {
  feeData.value.invoices.push(e.target.files[0])
  file.value = ''
}
function deleteFeeRow(index) {
  emits('deleteRow', index)
}

const triggerFileInput = () => {
  $(`#input-expense-reason-${props.id}-file`).click()
}

const removeFile = (index, file) => {
  feeData.value.invoices.splice(index, 1)
  feeData.value?.removes?.push(file.url)
}

function getAmount(amount){
  feeData.value.amount = amount
}

</script>

<style scoped>
</style>
